"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultCancellationRetentionPhoneNumber = exports.getInsuranceCountryTwoLetterCodeByName = exports.getInsuranceCountryNameByTwoLetterCode = exports.getInsuranceCountryNameByCode = exports.getInsuranceCountryNames = exports.getInsuranceCFMRAllowedOriginCountries = exports.getInsuranceAllowedOriginCountries = exports.getInsuranceCountries = exports.isRegionAllowed = exports.getRegionNamesAndCode = exports.getRegionPhonePrefix = exports.getRegionReferralAmountByCode = exports.getRegionLang = exports.getZeroDecimalCurrencies = exports.getPaymentMethodLimitsByRegion = exports.getPaymentMethodsByRegion = exports.getPaymentMethodsByCurrencyCode = exports.getCurrencyCodes = exports.getDefaultRegionName = exports.getDefaultRegionCode = exports.getRegionNameByCode = exports.getDefaultRegion = exports.isRegionPhoneNumberValid = exports.getRegionByCurrency = exports.getRegionByCode = exports.getRegionNames = exports.getRegionCodesSortedByKeyRegions = exports.getRegionCodes = exports.getRegions = exports.getDefaultPriorityPhoneNumber = exports.getPriorityPhoneNumberByCode = exports.getPriorityPhoneNumbers = void 0;
var currencies_1 = require("./currencies");
var extended_1 = require("./extended");
var insurance_1 = require("./insurance");
var paymentMethodLimitsByRegion_1 = require("./paymentMethodLimitsByRegion");
var paymentMethodsByRegion_1 = require("./paymentMethodsByRegion");
var priorityPhoneNumbers_1 = require("./priorityPhoneNumbers");
var regions_1 = require("./regions");
function regions(brand) {
    return extended_1.extendedRegions[brand || regions_1.LUXURY_ESCAPES];
}
function currencies(brand) {
    return currencies_1.currencies[brand || regions_1.LUXURY_ESCAPES];
}
function paymentMethodsByRegion(brand) {
    return paymentMethodsByRegion_1.paymentMethodsByRegion[brand || regions_1.LUXURY_ESCAPES];
}
function paymentMethodLimitsByRegion(brand) {
    return paymentMethodLimitsByRegion_1.paymentMethodLimitsByRegion[brand || regions_1.LUXURY_ESCAPES];
}
var zeroDecimalCurrencies = [
    "BIF",
    "CLP",
    "DJF",
    "GNF",
    "JPY",
    "KMF",
    "KRW",
    "MGA",
    "PYG",
    "RWF",
    "VND",
    "VUV",
    "XAF",
    "XOF",
    "XPF",
];
// Custom order of countries that are more important to LE, showing it before other countries on CP and admin
var REGIONS_START_ORDER = ["AU", "US", "GB", "NZ", "SG", "HK", "TW", "ZA", "QA", "MY"];
function getPriorityPhoneNumbers(brand) {
    return priorityPhoneNumbers_1.priorityPhoneNumbers[brand || regions_1.LUXURY_ESCAPES];
}
exports.getPriorityPhoneNumbers = getPriorityPhoneNumbers;
function getPriorityPhoneNumberByCode(regionCode, brand) {
    if (!regionCode) {
        return null;
    }
    var priorityNumbers = getPriorityPhoneNumbers(brand);
    if (priorityNumbers.length > 0) {
        var pNumber = priorityNumbers.find(function (phoneNumber) {
            return phoneNumber.code.toLowerCase() === regionCode.toLowerCase();
        });
        return pNumber ? pNumber : null;
    }
    return null;
}
exports.getPriorityPhoneNumberByCode = getPriorityPhoneNumberByCode;
function getDefaultPriorityPhoneNumber(brand) {
    return getPriorityPhoneNumbers(brand)[0];
}
exports.getDefaultPriorityPhoneNumber = getDefaultPriorityPhoneNumber;
function getRegions(brand) {
    return regions(brand);
}
exports.getRegions = getRegions;
function getRegionCodes(brand) {
    return regions(brand).map(function (region) { return region.code; });
}
exports.getRegionCodes = getRegionCodes;
function getRegionCodesSortedByKeyRegions(brand, excludedRegions) {
    var codes = excludedRegions
        ? getRegionCodes(brand).filter(function (code) { return !excludedRegions.includes(code); })
        : getRegionCodes(brand);
    var keyRegions = REGIONS_START_ORDER.filter(function (code) { return codes.includes(code); });
    var otherRegions = codes.filter(function (code) { return !REGIONS_START_ORDER.includes(code); });
    return {
        allRegionCodes: __spreadArray(__spreadArray([], keyRegions, true), otherRegions, true),
        lastKeyRegionIndex: keyRegions.length > 0 ? keyRegions.length - 1 : null,
    };
}
exports.getRegionCodesSortedByKeyRegions = getRegionCodesSortedByKeyRegions;
function getRegionNames(brand) {
    return regions(brand).map(function (region) { return region.name; });
}
exports.getRegionNames = getRegionNames;
function getRegionByCode(regionCode, brand) {
    if (!regionCode) {
        return null;
    }
    var specialRegionCodeMapping = {
        dk: "nl",
        se: "es",
        no: "it",
    };
    var mappedRegionCode = specialRegionCodeMapping[regionCode.toLowerCase()] ?
        specialRegionCodeMapping[regionCode.toLowerCase()] : regionCode;
    return regions(brand).find(function (region) { return region.code.toLowerCase() === mappedRegionCode.toLowerCase(); });
}
exports.getRegionByCode = getRegionByCode;
function getRegionByCurrency(currencyCode, brand) {
    return regions(brand).find(function (region) { return region.currencyCode.toLowerCase() === currencyCode.toLowerCase(); });
}
exports.getRegionByCurrency = getRegionByCurrency;
function isRegionPhoneNumberValid(_a) {
    var phoneNumber = _a.phoneNumber, regionCode = _a.regionCode, brand = _a.brand;
    var region = getRegionByCode(regionCode, brand);
    if (!(region === null || region === void 0 ? void 0 : region.phoneRegex)) {
        return true;
    }
    return region.phoneRegex.test(phoneNumber);
}
exports.isRegionPhoneNumberValid = isRegionPhoneNumberValid;
function getDefaultRegion(brand) {
    return regions(brand)[0];
}
exports.getDefaultRegion = getDefaultRegion;
function getRegionNameByCode(code, brand) {
    var region = getRegionByCode(code, brand);
    return (region && region.name) || null;
}
exports.getRegionNameByCode = getRegionNameByCode;
function getDefaultRegionCode(brand) {
    return regions(brand)[0].code;
}
exports.getDefaultRegionCode = getDefaultRegionCode;
function getDefaultRegionName(brand) {
    return regions(brand)[0].name;
}
exports.getDefaultRegionName = getDefaultRegionName;
function getCurrencyCodes(brand) {
    return Object.keys(currencies(brand));
}
exports.getCurrencyCodes = getCurrencyCodes;
function getPaymentMethodsByCurrencyCode(currencyCode, brand) {
    if (!currencies(brand)[currencyCode]) {
        return [];
    }
    return currencies(brand)[currencyCode].paymentMethods;
}
exports.getPaymentMethodsByCurrencyCode = getPaymentMethodsByCurrencyCode;
function getPaymentMethodsByRegion(regionCode, brand) {
    if (!paymentMethodsByRegion(brand)[regionCode]) {
        return [];
    }
    return paymentMethodsByRegion(brand)[regionCode].paymentMethods;
}
exports.getPaymentMethodsByRegion = getPaymentMethodsByRegion;
function getPaymentMethodLimitsByRegion(regionCode, brand) {
    if (!paymentMethodLimitsByRegion(brand)[regionCode]) {
        return [];
    }
    return paymentMethodLimitsByRegion(brand)[regionCode];
}
exports.getPaymentMethodLimitsByRegion = getPaymentMethodLimitsByRegion;
function getZeroDecimalCurrencies() {
    return zeroDecimalCurrencies;
}
exports.getZeroDecimalCurrencies = getZeroDecimalCurrencies;
function getRegionLang(brand) {
    return regions(brand).map(function (region) { return region.lang; });
}
exports.getRegionLang = getRegionLang;
function getRegionReferralAmountByCode(code, brand) {
    var region = getRegionByCode(code, brand);
    return (region && region.referralAmount) || null;
}
exports.getRegionReferralAmountByCode = getRegionReferralAmountByCode;
function getRegionPhonePrefix(brand) {
    return regions(brand).map(function (region) { return region.phonePrefix; });
}
exports.getRegionPhonePrefix = getRegionPhonePrefix;
function getRegionNamesAndCode(brand) {
    return regions(brand).map(function (region) { return ({
        name: region.name,
        code: region.code,
    }); });
}
exports.getRegionNamesAndCode = getRegionNamesAndCode;
function isRegionAllowed(brand, regionCode) {
    var code = regionCode || "AU";
    return regions(brand).some(function (region) { return region.code === code; });
}
exports.isRegionAllowed = isRegionAllowed;
var insuranceCountries = __spreadArray(__spreadArray([], insurance_1.COVER_GENIUS_COUNTRIES, true), insurance_1.UNIVERSAL_COUNTRIES, true);
function getInsuranceCountries() {
    return insuranceCountries;
}
exports.getInsuranceCountries = getInsuranceCountries;
function getInsuranceAllowedOriginCountries() {
    return insurance_1.ALLOWED_ORIGIN_COUNTRIES;
}
exports.getInsuranceAllowedOriginCountries = getInsuranceAllowedOriginCountries;
function getInsuranceCFMRAllowedOriginCountries() {
    return insurance_1.ALLOWED_CFMR_ORIGIN_COUNTRIES;
}
exports.getInsuranceCFMRAllowedOriginCountries = getInsuranceCFMRAllowedOriginCountries;
function getInsuranceCountryNames() {
    return insuranceCountries.map(function (country) { return country.name; });
}
exports.getInsuranceCountryNames = getInsuranceCountryNames;
function getInsuranceCountryNameByCode(code) {
    var insuranceCountry = insuranceCountries.find(function (country) { return country.code === code; });
    return insuranceCountry === null || insuranceCountry === void 0 ? void 0 : insuranceCountry.name;
}
exports.getInsuranceCountryNameByCode = getInsuranceCountryNameByCode;
function getInsuranceCountryNameByTwoLetterCode(twoLetterCode) {
    var insuranceCountry = insuranceCountries.find(function (country) { return country.two_letter_country_code === twoLetterCode; });
    return insuranceCountry === null || insuranceCountry === void 0 ? void 0 : insuranceCountry.name;
}
exports.getInsuranceCountryNameByTwoLetterCode = getInsuranceCountryNameByTwoLetterCode;
function getInsuranceCountryTwoLetterCodeByName(name) {
    var insuranceCountry = insuranceCountries.find(function (country) { return country.name === name; });
    return insuranceCountry === null || insuranceCountry === void 0 ? void 0 : insuranceCountry.two_letter_country_code;
}
exports.getInsuranceCountryTwoLetterCodeByName = getInsuranceCountryTwoLetterCodeByName;
function getDefaultCancellationRetentionPhoneNumber(brand) {
    var _a, _b;
    var auRegion = regions(brand).find(function (region) { return region.code === "AU"; });
    var retentionContact = auRegion === null || auRegion === void 0 ? void 0 : auRegion.contacts.find(function (contact) { return contact.type === "cancellationRetention"; });
    return {
        number: (_a = retentionContact === null || retentionContact === void 0 ? void 0 : retentionContact.local.number) !== null && _a !== void 0 ? _a : "1300739349",
        humanReadable: (_b = retentionContact === null || retentionContact === void 0 ? void 0 : retentionContact.local.humanReadable) !== null && _b !== void 0 ? _b : "1300 739 349",
    };
}
exports.getDefaultCancellationRetentionPhoneNumber = getDefaultCancellationRetentionPhoneNumber;
